/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from 'react';
import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';
import { Autocomplete, RenderInputParams } from '@material-ui/lab';
import { TextField, CircularProgress, ListItemText } from '@material-ui/core';
// import { showNotification } from '../../App';
import { IAutoCompleteItem } from '../../typings/autoComplete';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            // minWidth: '200px',
        },
    }),
);

const staticOptions: IAutoCompleteItem[] = [
    {
        label: 'Aged Care/Disability Services',
        value: 'Aged Care/Disability Services',
    },
    {
        label: 'Banking & Finance',
        value: 'Banking & Finance',
    },
    {
        label: 'Building & Construction',
        value: 'Building & Construction',
    },
    {
        label: 'Entertainment/Hospitality',
        value: 'Entertainment/Hospitality',
    },
    {
        label: 'Government',
        value: 'Government',
    },
    {
        label: 'Health & Education',
        value: 'Health & Education',
    },
    {
        label: 'Legal',
        value: 'Legal',
    },
    {
        label: 'Manufacturing',
        value: 'Manufacturing',
    },
    {
        label: 'Primary Industry',
        value: 'Primary Industry',
    },
    {
        label: 'Private Client',
        value: 'Private Client',
    },
    {
        label: 'Professional Services',
        value: 'Professional Services',
    },
    {
        label: 'Real Estate / Property',
        value: 'Real Estate / Property',
    },
    {
        label: 'Retail',
        value: 'Retail',
    },
    {
        label: 'Transport & Distribution',
        value: 'Transport & Distribution',
    },
    {
        label: 'Wholesale',
        value: 'Wholesale',
    },
]

interface AffinityIndustryClassificationSelectorProps {
    disabled?: boolean;
    required?: boolean;
    multiple?: boolean;
    // tslint:disable-next-line: no-any
    value?: IAutoCompleteItem | any; // value only available in single select
    error?: boolean;
    onSelection?: (value: IAutoCompleteItem | IAutoCompleteItem[], name: string) => void;
    className?: string;
    helperText?: string;
    name?: string;
    label?: string;
    disablePortal?: boolean;
    onBlur?: React.FocusEventHandler<HTMLDivElement>;
    filter?: {
        category?: string;
        state?: string;
    };
}


interface AffinityIndustryClassificationSelectorState {
    isLoading: boolean;
    options: IAutoCompleteItem[];
}

export const AffinityIndustryClassificationSelector: React.FC<AffinityIndustryClassificationSelectorProps> = (props) => {
    const classes = useStyles();

    const [state] = useState<AffinityIndustryClassificationSelectorState>({
        isLoading: false,
        options: staticOptions,
    });

    // tslint:disable-next-line: no-any
    const handleChange = (event: React.ChangeEvent<{}>, value: any) => {
        // tslint:disable-next-line: no-console
        console.log('onChange', value);
        if (props.onSelection) {
            props.onSelection(value, props.name ? props.name : 'matterType');
        }
    };

    const getInputProps = (params: RenderInputParams, isLoading?: boolean) => {
        return {
            ...params.InputProps,
            endAdornment: (
                <React.Fragment>
                    {isLoading ? <CircularProgress color="primary" size={20} /> : null}
                    {params.InputProps.endAdornment}
                </React.Fragment>
            ),
        };
    };

    return (
        <div className={`${classes.root} ${props.className}`}>
            {props.multiple ? (
                <Autocomplete
                    value={props.value}
                    loading={false}
                    multiple={true}
                    disabled={props.disabled}
                    onChange={handleChange}
                    options={state.options}
                    disablePortal={props.disablePortal} // to Stop the dropdown select from closing the form
                    // tslint:disable-next-line: jsx-no-lambda
                    getOptionLabel={(option: IAutoCompleteItem) => option.label}
                    getOptionSelected={(option, value) => value.value === option.value}
                    onBlur={props.onBlur}
                    // tslint:disable-next-line: jsx-no-lambda
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            label={props.label ? props.label : 'Matter Type'}
                            variant="standard"
                            fullWidth={true}
                            margin="none"
                            required={props.required}
                            InputProps={getInputProps(params, false)}
                            error={props.error}
                            helperText={props.helperText}
                        />
                    )}
                    // tslint:disable-next-line: jsx-no-lambda
                    renderOption={(option, { inputValue }) => {
                        // const matches = match(option.label, inputValue);
                        // const parts = parse(option.label, matches);

                        const selected = option.label === inputValue;
                        return (
                            <ListItemText
                                primary={<div style={{ fontWeight: selected ? 600 : 'inherit' }}>{option.label}</div>}
                                // secondary={`State: ${option.state}`}
                            />
                        );
                    }}
                />
            ) : (
                <Autocomplete
                    value={props.value}
                    loading={false}
                    disabled={props.disabled}
                    onChange={handleChange}
                    options={state.options}
                    disablePortal={props.disablePortal} // to Stop the dropdown select from closing the form
                    // tslint:disable-next-line: jsx-no-lambda
                    getOptionLabel={(option: IAutoCompleteItem) => option.label}
                    onBlur={props.onBlur}
                    // tslint:disable-next-line: jsx-no-lambda
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            label={props.label ? props.label : 'Matter Type'}
                            variant="standard"
                            fullWidth={true}
                            margin="none"
                            required={props.required}
                            InputProps={getInputProps(params, false)}
                            error={props.error}
                            helperText={props.helperText}
                        />
                    )}
                    // tslint:disable-next-line: jsx-no-lambda
                    renderOption={(option, { inputValue }) => {
                        // const matches = match(option.label, inputValue);
                        // const parts = parse(option.label, matches);
                        const selected = option.label === inputValue;
                        return (
                            <ListItemText
                                primary={<div style={{ fontWeight: selected ? 600 : 'inherit' }}>{option.label}</div>}
                                // secondary={`State: ${option.state}`}
                            />
                        );
                    }}
                />
            )}
        </div>
    );
};